import { cn } from '@/lib/utils';
import { ReactNode } from 'react';
import { InputError } from './Input';

interface InputWrapperAuthProps {
	value?: string | boolean;
	error?: string;
	label?: string;
	icon?: ReactNode;
	children?: ReactNode;
	className?: string;
	displayError?: boolean;
}

const InputWrapperAuth = ({
	error,
	label,
	icon,
	children,
	className,
	displayError = false,
}: InputWrapperAuthProps) => {
	return (
		<div
			className={cn(
				' focus-visible:ring-ring relative flex w-full items-center justify-between rounded-xl border border-zinc-400 p-2 ring-offset-0 transition-all duration-150 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-zinc-400 focus-within:ring-1 focus-within:ring-cyan-800 focus-within:ring-offset-1 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
				error && 'border-red-500 focus-within:ring-red-800',
				className,
			)}
		>
			<div className="flex w-full items-center gap-2">
				{icon && <div>{icon}</div>}
				<div className="w-full border-s border-zinc-400 ps-2">
					{label && (
						<p className="text-sm font-semibold text-zinc-700">
							{label}
						</p>
					)}
					{children}
				</div>
				<div className="absolute -bottom-[1.2rem] left-0">
					{error && displayError && <InputError error={error} />}
				</div>
			</div>
		</div>
	);
};

export { InputWrapperAuth };
